export enum SelectVersionModalActionsEnum {
	CONFIRM = 'confirm',
	ERROR = 'error'
}

export enum SelectVersionModalComparisonResultEnum {
	IS_SAME = 'isSame',
	IS_DIFFERENT = 'isDifferent',
	WILL_OVERWRITE = 'willOverwrite'
}


export enum SelectVersionModalVersionTypeEnum {
	DB = 'db',
	LOCAL = 'local'
}

export const SELECT_VERSION_MODAL_CONFIG = {
	translationPath: 'selectVersion',
	showDiffInit: true,
	showOverwriteInit: true,
	showResultInit: false,
	withClipboard: false,
	compareByIsoType: 'iso3' // not supported anymore (iso2) // TODO : refactor , remove iso2
};



